import AccessRequest from '@pages/403/index.js';
import BasePage from '@pages/BasePage.js';
import { UIDiv, UISpan, UIText } from '@ui';

export default class NotFound extends BasePage {
  constructor(errorType = 'not_found', resourceId = null, resourceType = null) {
    super();
    this.setId('notfound');

    if (errorType === 'unauthorized') {
      this.#showAccessRequest(resourceId, resourceType);
    } else {
      this.#showNotFound();
    }
  }

  #showAccessRequest(resourceId, resourceType) {
    const accessRequestPage = new AccessRequest(resourceType, resourceId);
    this.add(accessRequestPage);
  }

  #showNotFound() {
    const notfound = new UIDiv();
    notfound.setClass('notfound');

    const notfound404 = new UIDiv();
    notfound404.setClass('notfound-404');

    const oops = new UIText(i18next.t('notFound.notFound'));
    oops.setClass('oops');

    const numbers = new UIText();
    numbers.setClass('numbers-404');
    const firstNumber = new UISpan();
    firstNumber.setTextContent('4');
    firstNumber.setClass('number-404');
    firstNumber.setColor('#5581fb');
    const secondNumber = new UISpan();
    secondNumber.setTextContent('0');
    secondNumber.setClass('number-404');
    secondNumber.setColor('#FFC000');
    const thirdNumber = new UISpan();
    thirdNumber.setTextContent('4');
    thirdNumber.setClass('number-404');
    thirdNumber.setColor('#5581fb');

    numbers.add(firstNumber);
    numbers.add(secondNumber);
    numbers.add(thirdNumber);

    notfound404.add(oops);
    notfound404.add(numbers);

    const text = new UIText(i18next.t('notFound.notFoundText'));
    text.setClass('text-404');

    notfound.add(notfound404);
    notfound.add(text);

    this.add(notfound);
  }
}
